import { makeStyles } from '@mui/styles';

import Colors from 'configs/Colors';

const useStyles = makeStyles(() => ({
  dialogPaper: {
    backgroundColor: Colors.Black,
    margin: 0,
    maxWidth: '100%',
    maxHeight: '100%',
  },
  container: {
    display: 'flex',
    height: '100vh',
    width: '100vw',
    position: 'relative',
  },
  closeButton: {
    position: 'absolute !important',
    top: 16,
    right: 16,
    color: `${Colors.White} !important`,
    zIndex: 1000,
    backgroundColor: `${Colors.BlackTransparent4} !important`,
    '&:hover': {
      backgroundColor: `${Colors.BlackTransparent6} !important`,
    },
  },
  sidebar: {
    width: 300,
    backgroundColor: Colors.Grey10,
    overflowY: 'auto',
    padding: 24,
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    // Ẩn scrollbar nhưng vẫn cho phép scroll
    scrollbarWidth: 'none', // Firefox
    '&::-webkit-scrollbar': {
      display: 'none', // Chrome, Safari, Edge
    },
    msOverflowStyle: 'none', // IE and Edge
  },
  thumbnailItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    cursor: 'pointer',
    transition: 'opacity 0.3s ease',
    '&:hover': {
      opacity: 0.8,
    },
  },
  thumbnailItemActive: {
    border: `3px solid ${Colors.White}`,
    padding: 3,
  },
  thumbnailImage: {
    width: '100%',
    height: 167,
    objectFit: 'cover',
  },
  thumbnailMetadata: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  metadataText: {
    fontSize: 14,
    fontWeight: 200,
    lineHeight: '20px',
    letterSpacing: 0.56,
    color: Colors.White,
  },
  centerArea: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    padding: 40,
    background: Colors.Black,
  },
  mainImage: {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
  },
  navigationButton: {
    position: 'absolute !important',
    color: `${Colors.White} !important`,
    backgroundColor: `${Colors.BlackTransparent4} !important`,
    '&:hover': {
      backgroundColor: `${Colors.BlackTransparent6} !important`,
    },
  },
  prevButton: {
    left: 16,
  },
  nextButton: {
    right: 16,
  },
}));

export default useStyles;
